<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openDoc(row)">表单</Button>
        <Button size="small" @click="undo(row)">撤回</Button>
        <Button size="small" @click="openJincheng(row)">进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <jincheng ref="jincheng"></jincheng>
    <Modal title="表单详情" v-model="openForm" width="1000" footerHide>
      <docDetail :readonly="true" ref="docDetail"></docDetail>
    </Modal>

  </div>
</template>
<script>
import axios from "axios";
import jincheng from "./jincheng.vue";
import docDetail from "./docDetail.vue";
var flows = [];
export default {
  components: { jincheng, docDetail },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "流水号",
          key: "title",
        },
        {
          title: "流程名称",
          key: "flowName",
        },
        {
          title: "当前节点",
          key: "nodeName",
        },
        {
          title: "流转人",
          key: "perUser",
        },
        {
          title: "处理人",
          key: "addUser",
        },
        {
          title: "状态标签",
          key: "stateLable",
        },
        {
          title: "后续处理人",
          key: "auditorUser",
        },
        {
          title: "创建时间",
          key: "createTime2",
        },
        {
          title: "操作",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],


      searchItem: {
        keyWork: "",
        pageNumber: 1,
        pageSize: 50,
        startDate: 0,
        endDate: 0
      },
      total: 0,
      searchForms: [
        {
          title: "选择流程",
          key: "flowId",
          type: "Select",
          selectType: 'obj',
          selectItems: flows,
          times: "2,0",
        },
        {
          title: "时间范围",
          key: "startDate",
          key1: "endDate",
          type: "lyyymmdd",
          times: "2,0",
        }, /**/
      ],
      itemListForms: [
        {
          title: "报销用途",
          key: "reason",
          type: "Input",
          required: true,
        },
        {
          title: "金额",
          key: "money",
          type: "InputNumber",
          required: true,
        },
      ],
      itemListItem: {
        "reason": "",
        "money": 0
      },
      itemList: []
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");

      axios({
        method: "post",
        url: axios.flow + "/flow/historyList",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].createTime2 = this.utils.time(data[i].createTime);
          
        }
        this.tableData = data;
      });
    },

    //点击编辑按钮
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    openDoc(row) {
      this.openForm = true;
      this.$refs.docDetail.reach(row);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      console.log(this.searchItem);
      this.searchItem.startDate = this.searchItem.startTime;
      this.searchItem.endDate = this.searchItem.endTime;
      this.getList();
    },
    getFlows() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        flows.length = 0;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name
          }
          flows.push(obj)
        }
      });
    },
    undo(row) {
      this.$Modal.confirm({
        title: "是否继续撤回",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-common-server-flow/flow/undo",
            data: { flowStartId: row.flowStartId },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.getFlows();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/yibanchaxun.vue